import { SafetyPlanTestID } from "@/constants/TestID";
import SafetyPlanSection, {
  LinkText,
} from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import type { LinkPressProps } from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import { joinTestIDs } from "@/utils/string.util";

interface ChatSuicideLineSectionProps {
  onLinkPress: (props: LinkPressProps) => void;
  url?: string;
}

const ChatSuicideLineSection = ({
  onLinkPress,
  url,
}: ChatSuicideLineSectionProps) => {
  const chatSuicideLine = url
    ? [
        <LinkText
          key={SafetyPlanTestID.ChatSuicideLine}
          linkType="web"
          onPress={() => {
            onLinkPress({
              field: ChatSuicideLineSection.name,
              linkType: "web",
              text: url,
            });
          }}
          testID={SafetyPlanTestID.ChatSuicideLine}
          text={url}
        />,
      ]
    : [];

  return (
    <SafetyPlanSection
      statements={chatSuicideLine}
      testID={joinTestIDs(SafetyPlanTestID.ChatSuicideLine, "section")}
      title="Chat suicide line"
    />
  );
};

export default ChatSuicideLineSection;
